import DatePicker, { registerLocale } from 'react-datepicker';
// eslint-disable-next-line import/no-extraneous-dependencies
import ka from 'date-fns/locale/ka'; // the locale you want
// eslint-disable-next-line import/no-extraneous-dependencies
import am from 'date-fns/locale/hy'; // the locale you want
import './CustomerDatePicker.scss';
import moment from 'moment';
import 'moment/locale/ka';
import 'moment/locale/hy-am';
import { Form } from 'antd';
import { forwardRef } from 'react';
import { useLocation } from 'react-router-dom';
import { ReactComponent as Calendar } from '../../../../resources/images/svg/calendar.svg';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import useTranslation from '../../../hooks/translation/useTranslation';

function CustomerDatePicker({
  className,
  defaultLabel,
  errorMessage,
  noError = false,
  name,
  rules = [],
  form,
  label,
  defaultValue,
  minDate,
  clear = false,
  maxDate = false,
}) {
  registerLocale('ka', ka); // register it with the name you want
  registerLocale('am', am); // register it with the name you want
  const { width } = useWindowDimensions();
  const location = useLocation();

  const isHomePage = location.pathname === '/ka' || location.pathname === '/en' || location.pathname === '/am';

  const placement = isHomePage && width < 1024
    ? 'top'
    : 'bottom';
  const dateValue = Form.useWatch(name, form);
  const { dateLocale } = useTranslation();

  const customPopperPlacement = {
    positionFixed: false, // Setting positionFixed to false
  };

  // eslint-disable-next-line react/no-unstable-nested-components
  const CustomInput = forwardRef(({ onClick, value, children }, ref) => (
    <button
      type="button"
      className=" bg-transparent border-0 flex-[1] min-w-0 text-black text-center m-0 flex gap-2 items-center"
      ref={ref}
      onClick={onClick}
    >
      {children && !moment(value, 'DD/MM/YYYY').isValid() ? (
        <>
          <Calendar />
          {children}
        </>
      ) : (
        <div className="flex gap-2 lg:gap-1 items-center">
          <Calendar />
          {moment(value, 'DD/MM/YYYY')
            .format('DD.MM.YY')}
          {clear && value && (
            <button
              type="button"
              onClick={() => form.setFieldValue(name, undefined)}
              className="bg-gray-light-gr rounded-2xl p-1 border-0 text-black"
            >
              <div className="cross" />
            </button>
          )}
        </div>
      )}
    </button>
  ));

  return (
    <Form.Item
      label={label}
      name={name}
      validateStatus={errorMessage && 'error'}
      help={!noError && errorMessage}
      className={`customer-date-picker ${className}`}
      style={{ marginBottom: noError && 0 }}
      initialValue={defaultValue}
      rules={rules}
    >
      <DatePicker
        customInput={<CustomInput>{defaultLabel}</CustomInput>}
        locale={dateLocale}
        monthsShown={1}
        selected={moment(dateValue).isValid() ? dateValue : undefined}
        onChange={(value) => {
          form.setFieldValue(name, value);
        }}
        minDate={minDate || new Date()}
        popperPlacement={placement}
        popperModifiers={customPopperPlacement}
        maxDate={maxDate}
        dateFormat="dd/MM/yyyy"
      />
    </Form.Item>
  );
}

export default CustomerDatePicker;
